import { APIClient } from "./_api";

const endpoint = "/Image";

export function addImages(data) {
  let bodyFormData = new FormData();
  for (let key in data) {
    console.log(key, data[key])
    bodyFormData.append("Images", data[key]);
  }
  return APIClient.post(`${endpoint}`, bodyFormData);
}

export function addPDF(data) {
  let bodyFormData = new FormData();
  bodyFormData.append("Images", data);
  return APIClient.post(`${endpoint}/pdf`, bodyFormData);
}
